import { useEffect, useState } from "react";
import { WeeklyPage } from "../components/WeeklyPage";
import { on } from "events";
import { WeeklyHeader } from "../components/WeeklyHeader";

export const PreviosPerformance = ({
  list,
  onPageDataUpdated,
  weekData,
  pageIndex,
  subIndex,
  registerPageIndex,
  saveKey,
}: any) => {
  const getEmptyArray = () => {
    let result = [];
    for (let i = 0; i < 10; i++) {
      result.push({});
    }
    return result;
  };
  const [short, setShort] = useState<any>(
    weekData?.[saveKey]?.short ?? getEmptyArray()
  );
  const [toBlue, setToBlue] = useState<any>(
    weekData?.[saveKey]?.toBlue ?? getEmptyArray()
  );
  const onShortChange = (index: number, type: string, value: string) => {
    const newShorts = [...short];
    if (!newShorts[index]) newShorts[index] = {};
    newShorts[index][type] = value;
    setShort(newShorts);
    onPageDataUpdated(saveKey, "short", newShorts);
  };

  const onToBlueChange = (index: number, type: string, value: string) => {
    const newBlues = [...toBlue];
    if (!newBlues[index]) newBlues[index] = {};
    newBlues[index][type] = value;
    setToBlue(newBlues);
    onPageDataUpdated(saveKey, "toBlue", newBlues);
  };
  useEffect(() => {
    registerPageIndex(
      pageIndex,
      subIndex,
      `Bist ${list} - Önceki Hafta Analizleri`
    );
  }, [pageIndex]);
  const getValueColor = (value: string) => {
    if (!value) return "#fff";
    try {
      const floatValue = parseFloat(value);
      if (floatValue < 0) return "red";
      else return "rgb(96,198,108)";
    } catch {
      return "rgb(245,85,61)";
    }
  };
  const getValueFixed = (value: string) => {
    if (!value) return "";
    const floatVal = parseFloat(value);
    const strVal = floatVal.toFixed(2).replace("-", "").replace("+", "");
    const sign = floatVal >= 0 ? "+" : "-";
    return `${sign} %${strVal}`;
  };
  return (
    <WeeklyPage cropped pageId={`page-${pageIndex}-${subIndex}`}>
      <WeeklyHeader title={`BIST ${list} - ÖNCEKİ HAFTA ANALİZLERİ`} />

      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          gap: 10,
          fontSize: "20px",
          fontWeight: "600",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
            width: "100%",
          }}
        >
          <div
            style={{
              width: "50%",
              paddingInline: "10px",
            }}
          >
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                fontWeight: "bold",
                marginBottom: "10px",
                borderRadius: "2px",
              }}
            >
              Önceki Hafta Kısalan Kırmızı Barlar
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "5px 10px",
              }}
              className="no-print"
            >
              {Array(10)
                .fill(0)
                .map((_, index) => (
                  <div style={{ display: "flex", gap: 5 }}>
                    <input
                      className="no-print"
                      style={{ padding: 5, width: "50%" }}
                      placeholder="Hisse adı"
                      onChange={(e) =>
                        onShortChange(index, "stock", e.target.value)
                      }
                      value={short[index]?.stock ?? ""}
                    ></input>
                    <input
                      className="no-print"
                      style={{ padding: 5, width: "50%" }}
                      placeholder="Performans"
                      onChange={(e) =>
                        onShortChange(index, "value", e.target.value)
                      }
                      value={short[index]?.value ?? ""}
                    ></input>
                  </div>
                ))}
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: 16,
                paddingTop: 20,
                fontSize: "22px",
                fontWeight: "700",
              }}
              className="print-only-grid"
            >
              {Array(10)
                .fill(0)
                .map((_, index) => {
                  if (!short[index]?.stock) return null;

                  let val = parseFloat(short[index]?.value);
                  let backColor = "rgba(40,0,239,0.1)"; // 0 ise
                  let borderColor = "rgb(40,0,239)"; // 0 ise

                  if (val > 0) {
                    backColor = "rgba(60,170,129,0.1)";
                    borderColor = "rgb(60,170,129)";
                  } else if (val < 0) {
                    backColor = "rgba(236,82,74,0.1)";
                    borderColor = "rgb(236,82,74)";
                  }

                  return (
                    <div
                      key={index}
                      className="weekly-chip"
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        backgroundColor: backColor,
                        color: "black",
                        borderWidth: 1,
                        borderColor: borderColor,
                        borderStyle: "solid",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "12px 12px",
                        gap: 5,
                      }}
                    >
                      <span>{short[index]?.stock}</span>
                      <span>Performans</span>
                      <span>{getValueFixed(short[index]?.value)}</span>
                    </div>
                  );
                })}
            </div>
          </div>
          <div
            style={{
              width: "50%",
              paddingInline: "14px",
            }}
          >
            <div
              style={{
                backgroundColor: "#F7AF3D",
                padding: "5px 10px",
                fontWeight: "bold",
                marginBottom: "10px",
                borderRadius: "2px",
              }}
            >
              Önceki Hafta Maviye Dönenler
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "5px 10px",
              }}
              className="no-print"
            >
              {Array(10)
                .fill(0)
                .map((_, index) => (
                  <div style={{ display: "flex", gap: 5 }} key={index}>
                    <input
                      className="no-print"
                      style={{ padding: 5, width: "50%" }}
                      placeholder="Hisse adı"
                      onChange={(e) =>
                        onToBlueChange(index, "stock", e.target.value)
                      }
                      value={toBlue[index]?.stock ?? ""}
                    ></input>
                    <input
                      className="no-print"
                      style={{ padding: 5, width: "50%" }}
                      placeholder="Performans"
                      onChange={(e) =>
                        onToBlueChange(index, "value", e.target.value)
                      }
                      value={toBlue[index]?.value ?? ""}
                    ></input>
                  </div>
                ))}
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: 16,
                paddingTop: 20,
                fontSize: "18px",
                fontWeight: "700",
              }}
              className="print-only-grid"
            >
              {Array(10)
                .fill(0)
                .map((_, index) => {
                  if (!toBlue[index]?.stock) return null;

                  let val = parseFloat(toBlue[index]?.value);
                  let backColor = "rgba(40,0,239,0.1)"; // 0 ise
                  let borderColor = "rgb(40,0,239)"; // 0 ise

                  if (val > 0) {
                    backColor = "rgba(60,170,129,0.1)";
                    borderColor = "rgb(60,170,129)";
                  } else if (val < 0) {
                    backColor = "rgba(236,82,74,0.1)";
                    borderColor = "rgb(236,82,74)";
                  }

                  return (
                    <div
                      key={index}
                      className="weekly-chip"
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        backgroundColor: backColor,
                        color: "black",
                        borderWidth: 1,
                        borderColor: borderColor,
                        borderStyle: "solid",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "12px 12px",
                        borderRadius: "5px",
                        gap: 5,
                      }}
                    >
                      <span>{toBlue[index]?.stock}</span>
                      <span>Performans</span>
                      <span>{getValueFixed(toBlue[index]?.value)}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </WeeklyPage>
  );
};
